import cn from 'classnames';
import styles from './BonusesCard.module.scss';
import { useRouter } from 'next/router';
import { Palettes } from '@/types';
import { BonusIcon } from '../Icons';

type BonusesCardProps = {
  title: string;
  count: number;
  info?: {
    text: string;
    link: string;
  };
  className?: string;
  palette?: Palettes;
};

export function BonusesCard({
  title,
  count,
  info,
  palette = Palettes.Primary,
  className,
}: BonusesCardProps) {
  const bonusesCardClassName = cn(
    styles.bonusesCard,
    {
      [styles.secondary]: palette === Palettes.Secondary,
    },
    className,
  );
  const iconClassName = cn({
    [styles.iconSecondary]: palette === Palettes.Secondary,
  });
  const router = useRouter();

  return (
    <div className={bonusesCardClassName}>
      <div className={styles.bonusesCardHeading}>
        <BonusIcon className={iconClassName} />
        <span>{title}</span>
      </div>
      <div className={styles.bonusesCardAmount}>{count}</div>
      {info && (
        <p
          className={styles.bonusesCardInfo}
          onClick={() => router.push(info.link)}
        >
          {info.text}
        </p>
      )}
    </div>
  );
}
